import { render } from "./AboutMe.vue?vue&type=template&id=1aaf97c1&scoped=true&ts=true"
import script from "./AboutMe.vue?vue&type=script&lang=ts"
export * from "./AboutMe.vue?vue&type=script&lang=ts"

import "@/components/AboutMe/style.scss?vue&type=style&index=0&id=1aaf97c1&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf97c1"]])

export default __exports__